module.exports = __webpack_public_path__ + "static/media/SincerelyDiaryInterior4.94f5ef26.jpg";